import { generateTrackingIdentifier } from '../types/identifiers/trackingIdentifier';
import { ItemType } from './ItemType';
import { createGuid } from '../api/public/utils/Guid';
export const ItemHelper = {
    isContentItem: (item) => item.type !== ItemType.MenuItem &&
        item.type !== ItemType.NonSequencedFlow &&
        item.type !== ItemType.SequencedFlow &&
        item.type !== ItemType.Quiz &&
        item.type !== ItemType.ResourcesFolder,
    updateParentId: (item, parentId) => ({ ...item, parentId }),
    build: ({ type, title, parentId, ...props }) => {
        var _a, _b;
        return ({
            type,
            id: (_a = props.id) !== null && _a !== void 0 ? _a : createGuid(),
            parentId,
            trackingIdentifier: (_b = props.trackingIdentifier) !== null && _b !== void 0 ? _b : generateTrackingIdentifier(),
            title,
        });
    },
};
